module.exports = __webpack_public_path__ + "img/kaeptn_holger.ff83b311.png";